<template>
  <div>
    <div class="number__list">
      <div class="number__search" v-if="numberType === 'regional' && !busy">
        <autocomplete
          :search="search"
          @submit="onSubmit"
          @update="update"
          class="searchBox"
          placeholder="Search for a region or area code"
        ></autocomplete>
        <button type="button">
          <i class="fal fa-search"></i>
        </button>
      </div>
      <div v-show="busy" class="lds-ripple">
        <div></div>
        <div></div>
      </div>
      <ul class="number__results" v-show="numbers && !error && !busy">
        <li v-for="number in numberSet" :key="number">
          <input
            :id="number | trim"
            :checked="radioChecked(number)"
            :name="radioName"
            type="radio"
            class="pps-checkbox"
            :class="productVariant"
            @click="selectNumber(number)"
          />
          <label
            :for="number | trim"
            class="numbers__number"
            x-ms-format-detection="none"
          >
            <span class="icon icon--more-light"></span>
            <span class="icon icon--tick-light"></span>
            {{ number }}
          </label>
        </li>
        <li v-show="numbers && numbers.length === 0">No numbers found</li>
      </ul>
      <div v-if="error">{{ error }}</div>
      <div v-if="numbers">
        <button
          @click="prev"
          :disabled="prevBtnDisabled"
          class="prevButton"
        ></button>
        <button
          @click="next"
          :disabled="nextBtnDisabled"
          class="nextButton"
        ></button>
      </div>
    </div>
    <p class="smallPrint" v-if="numberType === 'freephone'">
      *0808 numbers are an additional £{{freephoneSurcharge}} per month and incur a 5p per minute
      additional charge for all incoming minutes for the total length of the
      call (rounded up to the next full minute).
    </p>
    <hr />
  </div>
</template>

<script>
import Autocomplete from "@trevoreyre/autocomplete-vue";
import NumberService from "@/services/NumberService.js";
import { eventBus } from "../main";

// skip
const skipTake = (skip, take, collection) => {
  const result = collection
    .filter((_, i) => i >= skip)
    .filter((_, i) => i < take);
  return result;
};
const getAreaCode = (searchTerm) => {
  const [areaCode] = searchTerm.split(/ (.*)/);
  return areaCode;
};

function getPrefix(numberType) {
  switch (numberType) {
    case "regional":
      return "0203";
    case "national":
      return "0330";
    case "freephone":
      return "0808";
    default:
      return "0";
  }
}

export default {
  components: { Autocomplete },
  props: {
    routeNumberType: String,
    freephoneSurcharge: Number
  },
  watch: {
    routeNumberType: function(type){
      this.$store.commit('setNumberType', type);
      this.getNumbers(type);
    },
    numberType: function (type) {
      this.getNumbers(type);
    },
    numbers(newSet) {
      this.setCount = 0;
      this.numberSet = skipTake(0, this.pageSize, newSet);
    },
  },
  data() {
    return {
      regions: [],
      numberSet: [],
      numbers: [],
      setCount: 0,
      searching: false,
      error: null,
      searchTerm: null,
      pageSize: 10,
      busy: false,
      product: null,
    };
  },

  mounted() {
    this.product = window.productType;
    this.regionFilters();
      
    this.getNumbers(this.numberType);
  },
  methods: {
    selectNumber(number) {
      eventBus.$emit("number-selected", number);
    },
    getNumbers(numberType, searchTerm) {
      this.error = null;
      const prefix =
        searchTerm && searchTerm.length > 2
          ? searchTerm
          : getPrefix(numberType);
      this.busy = true;

      NumberService.getNumbers(prefix)
        .then((response) => {
          this.numbers = response.data;
          this.busy = false;
        })
        .catch((error) => {
          this.error = error;
        });
    },
    async regionFilters() {
      return NumberService.getRegions()
        .then((response) => {
          this.regions = response.data;
        })
        .catch((error) => {
          this.error = "There was a problem retrieving region data";
        });
    },
    onSubmit(val) {
      if(val){
        this.searchTerm = getAreaCode(val);
        this.getNumbers("regional", this.searchTerm);
      }
    },
    search(input) {
      if (input.length < 1) {
        return [];
      }
      this.searchTerm = input;
      const regionFilter = this.regions.filter(
        (region) => region.toLowerCase().indexOf(input.toLowerCase()) !== -1 // when ie11 dies use .includes(input)
      );
      return regionFilter;
    },
    update(results, selectedIndex) {
      this.searching = results.length > 0;
    },
    radioChecked(number){
        return this.$store.getters.numbersCart.filter(item => item.number === number).length > 0 || this.$store.getters.ppsNumber === number;
    },
    next() {
      this.setCount += this.pageSize;
      this.numberSet = skipTake(this.setCount, this.pageSize, this.numbers);
    },
    prev() {
      this.setCount -= this.pageSize;
      this.numberSet = skipTake(this.setCount, this.pageSize, this.numbers);
    }
  },
  computed: {
    numberType() {
      return this.$store.getters.numberType;
    },
    prevBtnDisabled() {
      return this.setCount <= 0;
    },
    nextBtnDisabled() {
      return this.setCount >= this.numbers.length - this.pageSize;
    },
    productVariant() {
      return `${this.product}-variant`;
    },
    radioName() {
      if(this.product === 'PocketPhone'){
        return "numSelect";
      }
    }
  },
};
</script>
<style>
</style>
